export default __webpack_public_path__ + "static/media/dial.dc10fb77.gif";